<template>
  <div class="dinglogin">
    <p style="text-align:center;color:#e6a23c;font-size:20px;padding:40px;">{{msg}}</p>
    <div style="text-align:center;">
      <el-button v-if="type=='bind'" @click="homeout()" type="primary" plain>返回项目首页</el-button>
      <el-button @click="handleLogout()" type="warning" plain>返回登录页</el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { requestLogin,loginUserPermissions,dingTalkToUserInfo,userVerify,endconfirm } from '@/api/api.js'
import { getdata } from '@/api/apimock.js'
import { initDynamicRoutes } from '@/router/index.js'
export default {
  // 定义属性
  data() {
    return {
      phoneLogin:false,
      passwordLogin:true,
      formData: {
        username: "",
        password: "",
        originSign:'',
        code:'',
      },
      checked:true,
      formRule: {
        code: [{ required: true, message: `请输入验证码`, trigger: "blur" }],
        username: [{ required: true, message: `请输入账号/手机号`, trigger: "blur" }],
        password: [{ required: true, message: `请输入密码`, trigger: "blur" }],
      },
      recordsArr:[],
      authCode:'',
      state:'',
      msg:'',
      type:'',
    };
  },
  computed: {
    // ...mapState(['passwordLogin']),
    phoneRegex() {
      return /^1[3456789]\d{9}$/;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.getQueryString('authCode'));
    console.log(this.getQueryString('state'));
    this.authCode=this.getQueryString('authCode');
    this.state=this.getQueryString('state');
    if(this.authCode&&this.state){
      this.getdingTalkToUserInfo();
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getdingTalkToUserInfo(){
      let params = {
        authCode:this.authCode,
        state:this.state,
      }
      dingTalkToUserInfo(params).then(res => {
        if(res.data.code == 200){
              // this.$message({message: res.data.msg,type: 'success',duration:2000});
              this.$store.dispatch('setToken',res.data.data.token);
              localStorage.setItem('token',res.data.data.token);
              this.$store.dispatch('getuserInfo',res.data.data);
              localStorage.setItem('user_info',JSON.stringify(res.data.data));
              localStorage.setItem('originSign',res.data.data.origin_sign);
              localStorage.setItem('phone',res.data.data.phone);
              this.recordsArr=[];
              if(localStorage.getItem('recordsArr')&&localStorage.getItem('recordsArr')!='undefined'){
                this.recordsArr=JSON.parse(localStorage.getItem('recordsArr'));
                let records = this.recordsArr.findIndex(item => {
                  return item.phone == this.formData.username;
                });
                if(records==-1){
                  this.recordsArr.push({phone:res.data.data.phone,originSign:res.data.data.origin_sign});
                  localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
                }else{
                  this.recordsArr[records].phone=res.data.data.phone;
                  this.recordsArr[records].originSign=res.data.data.origin_sign;
                  localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
                }
              }else{
                this.recordsArr=[{phone:res.data.data.phone,originSign:res.data.data.origin_sign}];
                localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
              }
              loginUserPermissions({type:2}).then(res => {
                if(res.data.code == 200 ){
                  this.$store.commit('setRightList',res.data.data);
                  initDynamicRoutes();
                  if(res.data.data.length){
                    let routeData=res.data.data;
                    let settagsList=[{
                      title: routeData[0].children[0].route!=''?routeData[0].children[0].menu_name:routeData[0].children[0].children[0].menu_name,
                      path: routeData[0].children[0].route!=''?routeData[0].children[0].route:routeData[0].children[0].children[0].route,
                      name: routeData[0].children[0].route!=''?routeData[0].children[0].menu_name:routeData[0].children[0].children[0].menu_name,
                    }];
                    localStorage.setItem('settagsList',JSON.stringify(settagsList));
                    this.$router.push(routeData[0].children[0].route!=''?routeData[0].children[0].route:routeData[0].children[0].children[0].route);
                    localStorage.setItem('activePath',routeData[0].children[0].route!=''?routeData[0].children[0].route:routeData[0].children[0].children[0].route);
                  }else{
                    this.$message({ duration: 2000,showClose: true,message: '您暂无功能权限，请联系管理员！',type: 'error' });
                  }
                }
              })
        }else{
          this.type=res.data.data.type;
          this.msg=res.data.msg;
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      })
    },
    homeout(){
      this.$router.push('/saleKanban/manageSalesConsultant');
    },
    handleLogout() {
      localStorage.removeItem('user_info')
      localStorage.removeItem('token')
      localStorage.removeItem('rightList')
      localStorage.removeItem('settagsList')
      localStorage.removeItem('activePath')
      sessionStorage.removeItem('stateValue')
      sessionStorage.removeItem('searchformbox');
      // localStorage.setItem('originSign','');
      // this.$store.dispatch('setpasswordLogin', true);
      this.$router.push('/login');
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getLogin(){
          let params = {
            username:this.formData.username,
            password:this.passwordLogin?this.formData.password:'',
            originSign:this.formData.originSign,
            code:this.phoneLogin?this.formData.code:'',
          }
          requestLogin(params).then(res => {
            if(res.data.code == 200){
              this.$message({message: res.data.msg,type: 'success',duration:2000});
              this.$store.dispatch('setToken',res.data.data.token);
              localStorage.setItem('token',res.data.data.token);
              this.$store.dispatch('getuserInfo',res.data.data);
              localStorage.setItem('user_info',JSON.stringify(res.data.data));
              localStorage.setItem('originSign',res.data.data.origin_sign);
              localStorage.setItem('phone',res.data.data.phone);
              this.recordsArr=[];
              if(localStorage.getItem('recordsArr')&&localStorage.getItem('recordsArr')!='undefined'){
                this.recordsArr=JSON.parse(localStorage.getItem('recordsArr'));
                let records = this.recordsArr.findIndex(item => {
                  return item.phone == this.formData.username;
                });
                if(records==-1){
                  this.recordsArr.push({phone:res.data.data.phone,originSign:res.data.data.origin_sign});
                  localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
                }else{
                  this.recordsArr[records].phone=res.data.data.phone;
                  this.recordsArr[records].originSign=res.data.data.origin_sign;
                  localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
                }
              }else{
                this.recordsArr=[{phone:res.data.data.phone,originSign:res.data.data.origin_sign}];
                localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
              }
              loginUserPermissions({type:2}).then(permissionsRes => {
                if(permissionsRes.data.code == 200 ){
                  this.$store.commit('setRightList',permissionsRes.data.data);
                  initDynamicRoutes();
                  if(permissionsRes.data.data.length){
                    let settagsList=[{
                      title: permissionsRes.data.data[0].children[0].menu_name,
                      path: permissionsRes.data.data[0].children[0].route,
                      name: permissionsRes.data.data[0].children[0].menu_name
                    }];
                    localStorage.setItem('settagsList',JSON.stringify(settagsList));
                    this.$router.push(permissionsRes.data.data[0].children[0].route);
                    localStorage.setItem('activePath',permissionsRes.data.data[0].children[0].route);
                    userVerify().then(verifyRes => {
                      if(verifyRes.data.data.confirm == 0){
                        let titleName = `${verifyRes.data.data.month}月的任务金额为：${verifyRes.data.data.money}元, 请确认是否正常?`
                        this.$confirm(titleName, '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                          endconfirm({user_id:res.data.data.id,month:verifyRes.data.data.month}).then(endconfirmRes => {
                            if(endconfirmRes.data.code==200){
                              this.$message({ duration: 2000,showClose: true,message: '确认任务成功',type: 'success' });
                              this.getcommon();
                            }else{
                              this.$message({ duration: 2000,showClose: true,message: endconfirmRes.data.msg,type: 'error' });
                            }
                          });
                        }).catch(() => {
                          this.$message({ duration: 2000,showClose: true,type: 'info',message: '已取消'});
                        });
                      }
                    });
                  }else{
                    this.$message({ duration: 2000,showClose: true,message: '您暂无功能权限，请联系管理员！',type: 'error' });
                  }
                }
              })
            }else if(res.data.code == 10006){
              this.$message({ duration: 2000,showClose: true,message: '唯一标识错误或过期，需要验证码登陆',type: 'error' });
              this.phoneLogin=true;
              this.passwordLogin=true;
              localStorage.setItem('originSign','');
              this.formData.originSign='';
            }else{
              this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
          });
    },
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  .head {
    width: 100%;
    height: 70px;
    background-color: rgba(25, 26, 35, 1);
    display: flex;
    align-items: center;
    .head_img {
      width: 50px;
      height: 50px;
      margin-left: 37px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      margin-left: 30px;
    }
  }
  .content{
    background-repeat: no-repeat;
  }
  .content {
    position: relative;
    width: 100%;
    // height: calc(100% - 70px);
    height: 100%;
    .login_title{
      position: absolute;
      top: 24%;
      left: 10%;
      z-index: 3;
    }
    .bgColor{
      width:100%;
      height:100%;
      position: absolute;
      background: rgba(10,191,137,0.5);
      z-index: 1;
      top:0;
      left:0;
    }
    .form_data {
      position: absolute;
      bottom: 24%;
      right: 30px;
      width: 382px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px #cccccc;
      padding: 62px 55px 62px 55px;
      border-radius:20px;
      z-index: 2;
      h1 {
        font-size: 18px;
      }
      // .el-form {
      //   margin-top: 60px;
      //   margin-top: 40px;
      // }
      .submit {
        width: 100%;
      }
      .forget {
        float: right;
      }
    }
    .footer{
      position: absolute;
      bottom: 30px;
      left: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      ul{
        display: flex;
        li{
          margin-left: 10px;
        }
      }
      p{
        margin-top: 20px;
        font-weight: 400;
        font-style: normal;
        color: #CCCCCC;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
<style>
  .form_data .el-form-item{
    margin-bottom: 24px;
  }
  .el-button.disabled-style {
    background-color: #EEEEEE;
    color: #CCCCCC;
    border-color:#EEEEEE;
  }
  .code-input .el-input__inner, .el-input--underline-default .el-input__inner{
    /* border: none;
    border-bottom: 1px solid #DCDFE6;
    border-top: 1px solid #DCDFE6;
    border-left: 1px solid #DCDFE6;
    border-radius: 4px; */
    border-right:none;
  }
  .code-input .el-input-group__append {
    /* border: none;
    border-bottom: 1px solid #DCDFE6;
    border-top: 1px solid #DCDFE6;
    border-right: 1px solid #DCDFE6;
    border-radius: 4px; */
    background: #fff;
    color: #2bc58f;
    cursor: pointer;
    padding:0 10px;
  }
  .code-input .el-input-group__append .el-button{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/dingdinglogin.vue